<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.passwordCheck') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="mt-6">
            <v-col cols="12">
              <v-text-field
                :rules="[rules.required]"
                :label="$vuetify.lang.t('$vuetify.custom.adminCheckPassword')+'*'"
                type="password"
                v-model="formData.password"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                      :rules="[rules.required]"
                      :label="$vuetify.lang.t('$vuetify.custom.modifyPasswordTip')+'*'"
                      type="password"
                      v-model="formData.modifyPassword"
                      v-show="updateFlag"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" dark  @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
        <v-btn color="success" dark v-if="resetFlag"  @click="resetPassword">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
        <v-btn color="success" dark v-if="updateFlag" @click="popModPassword">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
        <v-btn color="success" dark v-if="checkPassword" @click="disableUser">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<style></style>
<script>
  import md5 from 'js-md5'
  export default {
    name: 'user-password',
    model:{
      prop:'resetPasswordDialog',
      event:'parent-event'
    },
    props:{
      dialog:Boolean,
      resetUserName:String,
      updateFlag:Boolean,
      resetFlag:Boolean,
      checkPassword:Boolean,
      userId:String
    },
    data: () => ({
      formData: {
        password: '',
        modifyPassword: '',//要重置的密码
      },
      rules: {
        required: value => !!value || '请输入'
      },
    }),
    methods:{
      async hiddenDialog(){
        this.$emit('parent-event',false);
        // this.checkPassword = false;
        // this.updateFlag = false;
        // this.resetFlag = false;
        await this.$emit('initialize')
        this.$refs.form.reset()
      },
      async disableUser(){
        this.formData.password = md5(this.$store.state.userInfo.username+this.formData.password);
        this.formData.username = this.resetUserName;
        let qualified = await this.$api.sysUser.passwordVerification(this.formData).then(data=>{
          if (data.flag) {
              return true;
            }else{
              this.$dialog.alert(data.msg);
              this.$refs.form.reset()
              return false;
            }
        })
        if(qualified){
          await this.$api.sysUser.updateUserLenable({id:this.userId,username:this.resetUserName}).then(data => {})
              this.$refs.form.reset()
              this.hiddenDialog();
        }
        
      },
      resetPassword() {
          this.formData.password = md5(this.$store.state.userInfo.username+this.formData.password);
          this.formData.username = this.resetUserName;
          this.$api.sysUser.resetPassword(this.formData).then(data => {
            if (data.flag) {
              this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.resetSuccess'));
              this.$refs.form.reset()
              this.hiddenDialog();
            }else{
              this.$dialog.alert(data.msg);
              this.$refs.form.reset()
            }
          })
      },
      popModPassword(){
        this.formData.password = md5(this.$store.state.userInfo.username+this.formData.password);
        this.formData.username = this.resetUserName;
        this.formData.modifyPassword = md5(this.formData.username + this.formData.modifyPassword);
        this.$api.sysUser.modifyPassword(this.formData).then(data => {
          if (data.flag) {
            this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.resetSuccess'));
            this.$refs.form.reset()
            this.hiddenDialog();
          }else{
            this.$dialog.alert(data.msg);
            this.$refs.form.reset()
          }
        })
      }
    },
    components:{md5},
  }
</script>
